module.exports = __webpack_public_path__ + "img/selected5-min.e764943e.png";